export const showErrorMessage = (message) => <small style={{ color: 'red', marginTop: '10px' }}>{message}</small>;

export const showSuccessMessage = (message) => <small style={{ color: 'green', marginTop: '10px' }}>{message}</small>;
